module.exports = __webpack_public_path__ + "assets/img/i5.cf8c5736.png";